import debounce from "lodash/debounce";
import { useEffect, useMemo, useState } from "react";

export function useDebounce<T>(value: T, delay = 300): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    const debouncedSetter = useMemo(
        () => debounce((val: T) => setDebouncedValue(val), delay),
        [delay],
    );

    useEffect(() => {
        debouncedSetter(value);
        return () => debouncedSetter.cancel();
    }, [value, debouncedSetter]);

    return debouncedValue;
}
